export const GetAllUsersQueryResolver = {
    getAllUsers: () => ({
        count: 1,
        users: [
            {
                id: '43c8f8ec-0772-41a2-a8e2-0b17fb57d4f1',
                email: 'qebpmadmin@deltekdev.onmicrosoft.com',
                role: 'Admin',
                status: 'Active',
                profileInfo: {
                    prefix: '',
                    firstName: 'Lorem ipsum dolor sit amet,',
                    lastName: 'Sed ut perspiciatis,',
                    suffix: '',
                    phone: '',
                    address: {
                        street1: '',
                        street2: '',
                        city: '',
                        region: 'Delaware',
                        country: 'United States',
                        postalCode: '',
                    },
                    professionalDiscipline: 'Building Product Manufacturer',
                    professionalRole: 'Building Product Manufacturer Manager',
                    title: '',
                    imageUrl:
                        'https://kpfileverstorageaccount.blob.core.windows.net/kp-verified/55e07e99-3b66-4ed9-b628-b5a2047ef75f/users/43c8f8ec-0772-41a2-a8e2-0b17fb57d4f1/images/profile/tJGJCTb7QqRkvhJIwzyZ_avataaars.png',
                },
            },
        ],
    }),
}
